<template>
     <div class="header">
        <div class="heading">
          Helix Wongani Chipofya
        </div>
        <div class="heading2">.NET Full Stack Software Engineer</div>
      </div>
      <!-- <img src="../assets/images/logo.gif" height="400"/> -->
</template>
<style scoped>
.heading2{
  font-size:2rem;
  color:var(--gold);
}
.heading{
  font-size:4rem;
  max-width:40rem;
  color:white;
}


@media(max-width: 768px){
  
  .heading{
    font-size:3rem;
    max-width:40rem;
    margin-top:1rem;
    color:white;
  }

  .heading2{
    font-size:1.6rem;
    margin-top:1rem;
  }
}
</style>